export function getProjects(state) {
  return state.projects
}
export function getCurrentProject(state) {
  return state.currentProject
}
